import { Amplify } from 'aws-amplify';

import outputs from "/amplify_outputs.json";

Amplify.configure(outputs);

export default Amplify; // Export Amplify if you need to access it directly